'use client';
import React, { useEffect, useMemo, useState } from 'react';

import { getLoyalties } from '@hooks/cache';

import { createGenericContext } from '../generateContext';

type ContextInterface = {
  isValidated?: boolean;
  setIsValidated?: React.Dispatch<React.SetStateAction<boolean>>;
};

const [useKocAliemContext, KocAliemContextProvider] =
  createGenericContext<ContextInterface>();

const IsKocAliemValidatedProvider = (
  props: React.PropsWithChildren<ContextInterface>
): React.JSX.Element => {
  const [isValidated, setIsValidated] = useState(
    () => !!getLoyalties()?.['activatedLoyalties']?.includes('KocAilem')
  );

  useEffect(() => {
    setIsValidated(
      !!getLoyalties()?.['activatedLoyalties']?.includes('KocAilem')
    );
  }, []);

  const value = useMemo(() => {
    return {
      isValidated,
      setIsValidated,
    };
  }, [isValidated]);

  return (
    <KocAliemContextProvider value={value}>
      {props.children}
    </KocAliemContextProvider>
  );
};
export { useKocAliemContext, IsKocAliemValidatedProvider };
